import { BiDislike, BiLike } from "react-icons/bi";
import { useEffect, useMemo, useState } from "react";
import "./style.css";
import useAnalysis from "../../../../../../../hooks/useAnalysis";
import CacheService from "../../../../../../../services/cache/CacheService";

enum eActions {
  DISLIKE = "dislike",
  LIKE = "like",
}

type Props = {
  assetId: string;
  reportId: number;
};

export default function InteractResumeButton({ assetId, reportId }: Props) {
  // States
  const [showButtons, setShowButtons] = useState<boolean>(false);
  const [isDone, setIsDone] = useState<boolean>(false);

  // Hooks
  const { createAnalysisInteraction } = useAnalysis();

  // Optimizers
  const cacheServiceInstance = useMemo(() => {
    return new CacheService();
  }, []);
  const cacheKey = `analysisReaction:${assetId}:${reportId}`;

  // Effects
  useEffect(() => {
    determineButtonVisibility();
  }, [assetId]);

  // Aditional Logic
  async function determineButtonVisibility() {
    const cacheValue = cacheServiceInstance.get(cacheKey);

    if (cacheValue) {
      return setShowButtons(false);
    }

    return setShowButtons(true);
  }

  function handleButtonClick(action: eActions) {
    setIsDone(true);

    setTimeout(() => {
      createAnalysisInteraction(assetId, action);
      setIsDone(false);
      setShowButtons(false);
      cacheServiceInstance.set(cacheKey, action, 7000);
    }, 2000);
  }

  // Rendereables
  if (isDone) {
    return (
      <div className="d-flex justify-content-center mg-t-20 mg-b-20">
        <i>Agradeço sua opinião, dessa forma vou evoluindo.</i>
      </div>
    );
  }

  if (showButtons) {
    return (
      <div
        className="d-flex justify-content-center mg-t-20 mg-b-20 animated fadeInDown update-text"
        style={{ gap: 20 }}
      >
        <BiLike
          className="resume-like-button"
          size={20}
          onClick={() => handleButtonClick(eActions.LIKE)}
        />
        <BiDislike
          className="resume-dislike-button"
          size={20}
          onClick={() => handleButtonClick(eActions.DISLIKE)}
        />
      </div>
    );
  }

  return <></>;
}
